"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_FORMAT = exports.DATE_FORMAT = void 0;
exports.DATE_FORMAT = 'YYYY-MM-DD';
exports.DISPLAY_FORMAT = 'DD.MM.YYYY';
